import dsBridge from 'dsbridge';

/**
 * 检测是否存在方法名
 *
 */
export function kkBridgeHasMethod(
  handlerName,
  type = 'all',
) {
  return dsBridge.hasNativeMethod(handlerName, type);
}

/**
 * app->js 注册方法供app调用
 * @param handlerName 方法名称
 * @param handler 接收方法
 * @param async 同步 false 异步 true
 */
export function kkBridgeReg(
  handlerName,
  handler,
  async = false,
) {
  if (async) {
    dsBridge.registerAsyn(handlerName, handler);
  } else {
    dsBridge.register(handlerName, handler);
  }
}

/**
 * 向app请求
 * @param { String } handlerName 方法名称
 * @param { Object } params 传递参数
 * @param { Boolean } async 是否是异步 默认同步 true 异步 false 同步
 * @return { * } promise 返回值
 */

export function kkBridgeCall(
  handlerName,
  params,
  async,
) {
  return (
    new Promise((resolve, reject) => {
      if (!handlerName) {
        reject(new Error('方法名必传'));
      }
      if (!dsBridge.hasNativeMethod(handlerName)) {
        reject(new Error(`没有提供${ handlerName }`));
      }
      // if (
      //   typeof params !== 'object'
      //   || Object.prototype.toString
      //     .call(params)
      //     .slice(8, -1)
      //     .toLowerCase() !== 'object'
      // ) {
      //   // params 必须为对象类型
      //   params = {};
      // }
      if (typeof async !== 'boolean') {
        // 是否有回调 必须为布尔值
        async = false;
      }
      if (async) {
        dsBridge.call(handlerName, JSON.stringify(params), (data) => {
          resolve(data);
        });
      } else {
        resolve(dsBridge.call(handlerName, JSON.stringify(params)));
      }
    })
  );
}

export const isWebview = () => kkBridgeHasMethod('getUserToken', 'syn');

// 获取token
export const getUserToken = async () => {
  const userToken = await kkBridgeCall('getUserToken', {}, false);
  return userToken;
};
// 设置标题
export const setTitle = (title) => {
  kkBridgeCall('setTitle', {
    title,
  });
};

// 设置右侧按钮
export const setNavRightBtn = (type, value) => {
  const params = {
    type,
    [type]: value,
  };
  kkBridgeCall('setNavRightBtn', params);
};

export const hideNavRightBtn = () => {
  kkBridgeCall('hideNavRightBtn', {});
};

// 点击右侧按钮
export const rightButtonClick = (callback) => {
  kkBridgeReg('rightButtonClicked', callback, false);
};

// 右侧按钮浮层
export const showNavSuperposedView = async (params) => {
  const data = await kkBridgeCall('showNavSuperposedView', params, true);
  return data;
};

// 打开新的webview

export const startNewWebViewPage = (url, finishCurrent = false) => {
  if (url) {
    kkBridgeCall('startNewWebViewPage', { url, finishCurrent }, false);
  }
};
/**
 * 页面截屏配置属性
 * @param modelName 模块名称
 * @param isIntercept 是否拦截截屏
 * @param isUpload 是否上传埋点
 */
export const setWebpageSettingInfo = (
  modelName,
  isIntercept = false,
  isUpload = false,
  interceptDesc = '合同涉及敏感信息，为了您的信息安全，请联系客服获取',
) => {
  if (kkBridgeHasMethod('setWebpageSettingInfo')) {
    kkBridgeCall(
      'setWebpageSettingInfo',
      {
        modelName, isIntercept, isUpload, interceptDesc,
      },
      false,
    );
  }
};
